/* Translate controls, never review text or rating data. */
(() => {
  const selector = '.jdgm-histogram__star[role="button"], .jdgm-revs-tab-btn, .jdgm-close-ico';
  function label(root) {
    if (!(root instanceof Element)) return;
    const controls = [...root.querySelectorAll(selector)];
    if (root.matches(selector)) controls.unshift(root);
    controls.forEach(control => {
      if (control.matches('.jdgm-close-ico')) {
        control.setAttribute('role', 'button');
        control.setAttribute('aria-label', 'Bewertungen schließen');
        control.setAttribute('tabindex', '0');
        if (!control.dataset.bbCloseReady) {
          control.dataset.bbCloseReady = 'true';
          control.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
          });
          control.addEventListener('keyup', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            control.click();
          });
          control.addEventListener('click', () => {
            requestAnimationFrame(() => document.querySelector('.jdgm-revs-tab-btn')?.focus());
          });
        }
        return;
      }
      if (control.matches('.jdgm-revs-tab-btn')) {
        control.setAttribute('aria-label', 'Kundenbewertungen öffnen');
        if (control.textContent.trim() === '★ Reviews') control.textContent = '★ Bewertungen';
        return;
      }
      const row = control.closest('.jdgm-histogram__row');
      const rating = row?.dataset.rating;
      const count = row?.dataset.frequency;
      if (!/^[1-5]$/.test(rating || '') || !/^\d+$/.test(count || '')) return;
      const stars = rating === '1' ? 'Stern' : 'Sternen';
      const reviews = count === '1' ? 'Bewertung' : 'Bewertungen';
      control.setAttribute('aria-label', `${count} ${reviews} mit ${rating} ${stars} anzeigen`);
    });
  }
  label(document.body);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(label));
  }).observe(document.body, { childList: true, subtree: true });
})();

